var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Section")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(
        _vm._s(_vm.$t("ContinuousReportSummary.Results.TargetSummary.Target"))
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ml-3" }, [
      _c("span", { staticClass: "mt-0" }, [
        _vm._v(_vm._s(_vm.$t("Instructions.Question")))
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(
            _vm.$t(
              "ContinuousReportSummary.Results.TargetSummary.TargetSummaryResults"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.$t("ContinuousReportSummary.Results.TargetSummary.NotesTooltip")
          )
        )
      ])
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(
        _vm._s(_vm.$t("ContinuousReportSummary.Results.OperationTotalsCorrect"))
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t(
            "ContinuousReportSummary.Results.OperationTotalsCorrect_Instructions"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(
        _vm._s(_vm.$t("ContinuousReportSummary.Results.RevisedOperationTotals"))
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }